// The `?post=<id>` a page was opened with, captured the moment this module
// loads. Pages rewrite their own query on mount (a collection page normalizes
// its filters) and the feed that opens the thread mounts later, lazily — by
// then the param can be gone. Import this from something in the page's first
// bundle so the capture happens before any of that.

export const POST_PARAM = 'post'

export function parsePostParam(search: string): number | null {
	const raw = new URLSearchParams(search).get(POST_PARAM)
	return raw && /^\d{1,15}$/.test(raw) ? Number(raw) : null
}

let linked: number | null = typeof window === 'undefined' ? null : parsePostParam(window.location.search)

/// The link's post, once: whoever opens it consumes it.
export function takeLinkedPost(): number | null {
	const id = linked
	linked = null
	return id
}
